// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WUNuI","borderTop":"styles_borderTop__1MpT6","description":"styles_description__15S5O"};